import React, { FC } from "react";
import { RETIREMENT_DESCRIPTION, RETIREMENT_REDIRECT_URL, RETIREMENT_TITLE } from "@shared/utils/retirement";

import DataSiftRedirect from "../DataSiftRedirect";

/**
 * Full-screen retirement notice shown to non-superadmin accounts on retired
 * hosts. Displays the retirement message and auto-redirects to the new
 * application after a short delay (with a manual "continue" button as well).
 */
const RetirementRedirect: FC = () => (
  <DataSiftRedirect
    redirectUrl={RETIREMENT_REDIRECT_URL}
    autoRedirectTime={5}
    title={RETIREMENT_TITLE}
    description={RETIREMENT_DESCRIPTION}
    buttonText="Go to the new application"
  />
);

export default RetirementRedirect;
